import {numberWithSpaces} from "../../../utils/amountTransformation";

const warrantyValidator = (value: string) => {
  const regex: RegExp = /^[1-9]\d*$/;
  return regex.test(value);
};
const warrantyFormatter = (value: string) => numberWithSpaces(value);
const warrantyReverter = (value: string) => value.replace(/\s/g, "");

export const warrantyValidation = {
  validator: warrantyValidator,
  message: "Warranty must be a number",
};
export const warrantyFormat = {
  formatter: warrantyFormatter,
  reverter: warrantyReverter,
};